import * as R from 'ramda';


export default function BulkDeleteControlsDialogController(
  $rootScope,
  $scope,
  $q,
  ssDialogService,
  alerts,
  loaderService,
  controlDataService,
  bulkDeleteControlsConfirmDialog
) {
  const vm = this;
  vm.deleteIsSelected = false;
  vm.hasData = true;
  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleBulkDeleteDialogClick = _handleBulkDeleteDialogClick;
  vm.handleSelectAll = _handleSelectAll;
  /** ************************************************
   * Event Handlers
   */
  activate();

  function activate() {
    $scope.$on('selectBulkControlChange', () => {
      _handleSelectAssetChange();
    });
  }

  function _handleBulkDeleteDialogClick($event) {
    const _ids = [];
    R.forEach((item) => {
      if (item.isBulkDelete === true) {
        _ids.push(item.customerControlId);
      }
    }, vm.controlType.customerControls);

    ssDialogService.dialogs.controlAdmin.bulkDeleteControlsConfirmDialog = ssDialogService.alert(
      bulkDeleteControlsConfirmDialog.getOptions($event, {
        controls: _ids,
        updateCallBack: _broadcastEvents,
      })
    );
    ssDialogService.show(ssDialogService.dialogs.controlAdmin.bulkDeleteControlsConfirmDialog);
  }

  function _handleCloseDialog() {
    ssDialogService.hide(ssDialogService.dialogs.controlAdmin.bulkDeleteControlsDialog);
  }

  function _handleSelectAll() {
    R.forEach(
      (risk) => {
        risk.isBulkDelete = vm.selectAll;
        vm.deleteIsSelected = vm.selectAll;
      },
      vm.controlType.customerControls
    );
  }

  function _handleSelectAssetChange() {
    const selectedIds = [];
    R.forEach((item) => {
      if (item.isBulkDelete === true) {
        selectedIds.push(item.customerControlId);
      }
    }, vm.controlType.customerControls);
    vm.deleteIsSelected = selectedIds.length > 0;
    vm.selectAll = selectedIds.length === vm.controlType.customerControls.length;
  }

  /** ************************************************
   * Private Functions
   */
  function _broadcastEvents() {
    $rootScope.$broadcast('refreshControlType', { customerControlTypeId: vm.controlType.customerControlTypeId });
    // ssDialogService.hide(ssDialogService.dialogs.riskAdmin.bulkDeleteRisksDialog);
  }
}

BulkDeleteControlsDialogController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  'ssDialogService',
  'alerts',
  'loaderService',
  'controlDataService',
  'bulkDeleteControlsConfirmDialog',
];
